import { render, staticRenderFns } from "./NameStatusMortgage.vue?vue&type=template&id=2cca1402"
import script from "./NameStatusMortgage.vue?vue&type=script&lang=js"
export * from "./NameStatusMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports